import { render, staticRenderFns } from "./ExtensionesReportComponent.vue?vue&type=template&id=bb853fbe&"
import script from "./ExtensionesReportComponent.vue?vue&type=script&lang=js&"
export * from "./ExtensionesReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionesReportComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports